import { useMutation } from '@/core/hooks/use-mutation'
import { addToast } from '@heroui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { resetPassword } from '../../providers/client'
import { useEmailAuthStore } from '../../store/email-auth'
import { resetPasswordSchema } from '../../types/dtos/reset-password.dto'

export const useResetPassword = ({
  onSuccess,
  onClose,
}: {
  onSuccess: () => void
  onClose: () => void
}) => {
  const t = useTranslations()
  const { email, reset } = useEmailAuthStore()
  const form = useForm({
    defaultValues: {
      email,
      password: '',
      password_confirmation: '',
      otp_code: '',
    },
    resolver: zodResolver(resetPasswordSchema),
  })

  const { isPending, mutate } = useMutation({
    mutation: resetPassword,
    onSuccess() {
      reset()
      onSuccess()
      addToast({
        title: t('resetPassword.success'),
        color: 'success',
      })
    },
    onError(error, data) {
      let showError = false
      Object.keys(data).forEach(key => {
        if (error.split(' ')?.some(e => e === key)) {
          showError = true
          form.setError(key as keyof typeof data, { message: error })
        }
      })

      if (!showError) {
        form.setError('otp_code', { message: error })
      }
    },
  })

  useEffect(() => {
    if (!email) onClose()
  }, [email, onClose])

  const handleSubmit = form.handleSubmit(mutate)

  return { form, handleSubmit, isPending }
}
